export const types = {
  associations: "[GET] Associations",
  notifications: "[GET] Notifications",
  codes: "[GET] Codes",
  products: "[GET] Products",
  isLoadingProducts: "IsLoadingProducts",
  b2bUsers: "[GET] B2BUsers",
};
